import React from 'react';
import PropTypes from 'prop-types';
import {List, ListItem, ListItemText} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';
import {ArrowForward, KeyboardArrowLeft, KeyboardArrowRight, ModeEdit} from "@material-ui/icons"
import {Button, Checkbox, Drawer, FormControl, IconButton, Input, InputLabel, ListItemSecondaryAction, Menu,
    MenuItem, Select, TextField, Typography} from "@material-ui/core";
import $ from 'jquery';
import C from './../../Constants';
import green from "@material-ui/core/es/colors/green";
import red from "@material-ui/core/es/colors/red";
import grey from '@material-ui/core/colors/grey'
import {DatePicker} from "material-ui-pickers";
import moment from "moment";

const styles = theme => ({
    drawer: {
        maxWidth: "75%",
    },
    nested: {
        paddingLeft: theme.spacing.unit * 4,
    },
    drawerEntries: {
        minWidth: "300px",
    },
    contactDataLabelFocusedOk: {
        color: green[500],
    },
    contactDataLabelFocusedError: {
        color: red[500],
    },
    contactDataInkbarOk: {
        '&:after': {backgroundColor: green[500]}
    },
    contactDataInkbarError: {
        '&:after': {backgroundColor: red[500]}
    },
    repeatToogleTextSeperator: {
        width: "5%"
    },
    formControl: {},
    repeatEveryValue: {
        width: "35px",
        marginRight: theme.spacing.unit * 2,
    },
    repeatEveryUnit: {
        width: "90px"
    },
    repeatUntil: {
        width: "100px"
    },
    repeatToggleColorOn: {
        paddingLeft: theme.spacing.unit * 2,
        paddingRight: theme.spacing.unit * 2,
        width: "45%",
        color: grey[800]
    },
    repeatToggleColorOff: {
        paddingLeft: theme.spacing.unit * 2,
        paddingRight: theme.spacing.unit * 2,
        width: "45%",
        color: grey[500]
    },
    repeatHelperText: {
        margin: theme.spacing.unit
    },
    repeatDays: {
        paddingRight: theme.spacing.unit * 1,
        display: "inline-block",
    },
    repeatPrayers: {
        paddingRight: theme.spacing.unit * 1,
        paddingLeft: theme.spacing.unit * 1,
        paddingBottom: theme.spacing.unit * 0.2,
        paddingTop: theme.spacing.unit * 0.2,
        display: "inline-block",
        //backgroundImage: "url('./resources/stroke.png')"
        //backgroundBlendMode: "multiply",
    },
    agbCheckboxText: {
        color: grey[500],
        maxWidth: theme.spacing.unit * 45,
    }
});

class EditHourDrawer extends React.Component {

    state = {
        name: "",
        nameError: false,
        entryNumber: 0,
        contact: "",
        open: false,
        hourNameSuggestionsOpen: false,
        hourType: this.props.allowedHourTypes != null && this.props.allowedHourTypes.length > 0 ? this.props.allowedHourTypes[0] : null,
        to: moment().startOf('day').add(1, 'week'),
        repeatEveryValue: 1,
        repeatEveryUnit: "week",
        agbAccepted: false,
    };

    componentDidMount() {
        for (const x in this.refs) {
            this.refs[x].onkeypress = (e) =>
                this.handleKeyPress(e, this.refs[x]);
        }
    }

    render() {
        if (!this.props.open && this.props.hour == null) return null;
        const that = this;
        const {classes} = this.props;
        const entries = this.convertEntries();
        const existingEntriesGreaterZero = entries != null && entries.length > 0;
        let otherExistingEntries = null;

        const repeatedDates = [];
        if(this.state.repeatActivated && this.state.repeatEveryUnit != null && this.state.repeatEveryValue > 0){
            const dateIterator = this.props.hour.date.clone();
            //repeatedDates = dateIterator.format("DD.MM");
            while (!dateIterator.isAfter(this.state.to)){
                repeatedDates.push(<Typography className={classes.repeatDays}>{dateIterator.format("DD.MM")}</Typography>);
                dateIterator.add(this.state.repeatEveryValue, this.state.repeatEveryUnit);
            }
        }
        if (existingEntriesGreaterZero){
            otherExistingEntries = $.map(entries, (entry) => {
                let color = that.props.hourTypes.find((hourType) => hourType.hourType == entry.type).color;
                return <Typography className={classes.repeatPrayers} style={{backgroundColor: color}}>{entry.name},</Typography>;
            })
        }

        return <Drawer anchor="right" open={this.props.open} onClose={this.toggleDrawer} className={classes.drawer}>
            <List className={classes.drawerEntries}>
                <ListItem>
                    <ListItemText primary={this.props.hour.date.format("ddd DD MMMM")}
                                  secondary={"von " + this.props.hour.hour + " bis " + (this.props.hour.hour + 1)}/>
                    <ListItemSecondaryAction>
                        <IconButton aria-label="close drawer" color="secondary" onClick={this.toggleDrawer}>
                            <ArrowForward/></IconButton></ListItemSecondaryAction>
                </ListItem>
                <ListItem>
                    <TextField label="Ihr Name" value={this.state.name} onChange={this.changeValueByEvent('name')}
                               fullWidth onClick={this.hourNameSuggestionsActive(true)} error={this.state.nameError}/>
                    {existingEntriesGreaterZero ?
                        <Menu onClose={this.hourNameSuggestionsActive(false)} open={this.state.hourNameSuggestionsOpen}
                              anchorEl={this.state.hourNameSuggestionsAnchor}>
                            <MenuItem button onClick={this.changeNameAdminMode("")}>Neuer Eintrag</MenuItem>
                            {$.map(entries, (entry) => {
                                let color = that.props.hourTypes.find((hourType) => hourType.hourType == entry.type).color;
                                return <MenuItem style={{backgroundColor: color}} button
                                                 onClick={this.changeNameAdminMode(entry.name)}>{entry.name}</MenuItem>
                            })}
                        </Menu> : null}
                </ListItem>
                <ListItem>
                    {this.contactData()}
                </ListItem>
                <ListItem>
                    {this.props.allowedHourTypes == null || this.props.allowedHourTypes.length <= 0 ? null
                        : (this.props.allowedHourTypes.length > 1 ?
                            <FormControl fullWidth>
                                <InputLabel htmlFor="hourTypeSelect">Stundentyp</InputLabel>
                                <Select
                                    ref="HourType"
                                    value={this.state.hourType}
                                    onChange={this.changeValueByEvent('hourType')}
                                    input={<Input id="hourTypeSelect" value=""/>}>
                                    {this.props.hourTypes.filter((hourType) => {
                                        return this.props.isAdmin || this.props.allowedHourTypes.indexOf(hourType.hourType) >= 0
                                    }).map(hourType => {
                                        return <MenuItem style={{backgroundColor: hourType.color}}
                                                         key={hourType.hourType}
                                                         value={hourType.hourType}>{C.hourTypeIdToNameMapping[hourType.hourType]}</MenuItem>;
                                    })}
                                </Select></FormControl>
                            : <ListItemText primary={C.hourTypeIdToNameMapping[this.props.allowedHourTypes[0]]}
                                            secondary="Stundentyp"/>)}
                </ListItem>

                <ListItem>
                    <Typography align="right" className={this.state.repeatActivated ? classes.repeatToggleColorOff : classes.repeatToggleColorOn} onClick={this.toggleValue('repeatActivated')}>einmalig</Typography>
                    <Typography className={classes.repeatToggleTextSeperator}>/</Typography>
                    <Typography align="left" className={this.state.repeatActivated ? classes.repeatToggleColorOn : classes.repeatToggleColorOff} onClick={this.toggleValue('repeatActivated')} >wiederholen</Typography>
                </ListItem>
                {this.state.repeatActivated ? [<ListItem>
                    <Typography className={classes.repeatHelperText}>alle</Typography>
                    <TextField value={this.state.repeatEveryValue}
                               onChange={this.changeValueByEvent('repeatEveryValue')} type="number"
                               className={classes.repeatEveryValue}/>
                    <TextField value={this.state.repeatEveryUnit} onChange={this.changeValueByEvent('repeatEveryUnit')}
                               select className={classes.repeatEveryUnit}>
                        <MenuItem key={"day"}
                                  value={"day"}>{this.state.repeatEveryValue > 1 ? "Tage" : "Tag"}</MenuItem>
                        <MenuItem key={"week"}
                                  value={"week"}>{this.state.repeatEveryValue > 1 ? "Wochen" : "Woche"}</MenuItem>
                        <MenuItem key={"month"}
                                  value={"month"}>{this.state.repeatEveryValue > 1 ? "Monate" : "Monat"}</MenuItem>
                    </TextField>
                    <Typography className={classes.repeatHelperText}>bis</Typography>
                    <DatePicker leftArrowIcon={<KeyboardArrowLeft/>} rightArrowIcon={<KeyboardArrowRight/>}
                        className={classes.repeatUntil} value={this.state.to} onChange={this.changeValue('to')}
                    />
                </ListItem>,
                    <ListItem><div style={{maxWidth: "400px"}}>{repeatedDates}</div></ListItem>] : null}
                {this.props.isAdmin ? null : <ListItem onClick={this.toggleValue("agbAccepted")}>
                    <Checkbox checked={this.state.agbAccepted}/>
                    <Typography align="left" className={classes.agbCheckboxText}>Meine Daten dürfen zum Zweck der Organisation von dieser 24/7-Woche gespeichert werden - öffentlich erscheint nur der Name.</Typography>
                </ListItem>}
                {this.state.entryNumber === 0 ?
                    <ListItem button>
                        <Button ref="insert" variant="raised" disabled={!this.state.agbAccepted && !this.props.isAdmin}
                                style={{width: "100%"}} color="secondary" onClick={this.insertHour}>eintragen</Button>
                    </ListItem> :
                    [<ListItem button key="update">
                        <Button ref="update" variant="raised" style={{width: "100%"}} color="secondary" onClick={this.updateHour}>update</Button></ListItem>,
                        <ListItem button key="delete">
                            <Button ref="delete" variant="raised" style={{width: "100%"}} color="secondary" onClick={this.deleteHour} key="delete">löschen</Button></ListItem>]
                       }
                {this.props.groupData != null && this.props.groupData.groupContactEmail != null
                    && this.props.groupData.groupContactEmail != "" ?
                        <ListItem>
                            <ListItemText primary={this.props.groupData.groupContactEmail}
                                          secondary={"Bei Fragen, DSGVO Widerruf oder Stunde falsch eingetragen"}/>
                        </ListItem> : null
                }
                {existingEntriesGreaterZero ?
                    <ListItem><div style={{maxWidth: "400px"}}>
                        <Typography className={classes.repeatDays}>Weitere Beter zu dieser Stunde:</Typography>{otherExistingEntries}</div></ListItem>
                    : null}
                {this.props.groupData.hourTypes.map((hourType) => {
                    return <ListItem className={classes.nested} key={"h" + hourType.hourType}
                                     style={{backgroundColor: hourType.color}}>
                        <ListItemText primary={C.hourTypeIdToNameMapping[hourType.hourType]}/>
                    </ListItem>
                })}
            </List>
        </Drawer>;
    }

    hourNameSuggestionsActive = (active) => (event) => {
        this.setState({
            hourNameSuggestionsOpen: active && this.props.isAdmin,
            hourNameSuggestionsAnchor: event.currentTarget
        });
    };

    convertEntries() {
        let entries = [];
        if (this.props.hour.entries != null) {
            let j = 0;
            const numberOfEntries = Object.keys(this.props.hour.entries).length;
            for (let i = 1; j < numberOfEntries && i < 1000; i++) { //most probably never more than 1000 entries per hour
                if(this.props.hour.entries[i] != null){
                    entries[j++] = this.props.hour.entries[i];
                }
            }
        }
        return entries;
    }

    contactData() {
        const {classes} = this.props;
        const error = !this.checkContactDataInput(this.props.contactData, this.state.contact);
        const labelColor = error ? classes.contactDataLabelFocusedError : classes.contactDataLabelFocusedOk;
        const inkbarColor = error ? classes.contactDataInkbarError : classes.contactDataInkbarOk;
        return <FormControl className={classes.formControl} fullWidth>
            <InputLabel FormControlClasses={{focused: labelColor}} htmlFor="contactDataInput">
                {this.contactDataLabel()}
            </InputLabel>
            <Input fullWidth value={this.state.contact} onChange={this.changeValueByEvent('contact')}
                   classes={{inkbar: inkbarColor,}} id="contactDataInput" ref="contactData"/>
        </FormControl>;
    }

    contactDataLabel() {
        if (this.props.contactData === C.CONTACT_DATA_EMAIL) return "Email";
        if (this.props.contactData === C.CONTACT_DATA_CELLPHONE) return "Handynummer";
        if (this.props.contactData === C.CONTACT_DATA_NONE) return "Kontakdaten";
        return "";
    }

    changeValueByEvent = key => event => this.setState({[key]: event.target.value});
    changeValue = key => value => this.setState({[key]: value});
    toggleValue = key => () => this.setState({[key]: !(this.state[key])});
    toggleDrawer = () => {
        this.resetEditHourDrawer();
        this.props.hoursPanel.toggleEditHourDrawer();
    };
    insertHour = () => {
        if (this.props.isAdmin || this.state.name != "") {
            if (this.state.repeatActivated && this.state.repeatEveryUnit != null && this.state.repeatEveryValue > 0) {
                let dateIterator = this.props.hour.date.clone();
                while (!dateIterator.isAfter(this.state.to)) {
                    this.props.hoursPanel.insertHour(dateIterator, this.props.hour.hour, this.state.name, this.state.contact, this.state.hourType, this.state.entryNumber);
                    dateIterator = dateIterator.add(this.state.repeatEveryValue, this.state.repeatEveryUnit);
                }
            } else {
                this.props.hoursPanel.insertHour(this.props.hour.date, this.props.hour.hour, this.state.name, this.state.contact, this.state.hourType, this.state.entryNumber);
            }
            this.resetEditHourDrawer();
        } else {
            this.setState({nameError: true});
        }
    };
    updateHour = () => {
        this.props.hoursPanel.updateHour(this.props.hour.date, this.props.hour.hour, this.state.name, this.state.contact, this.state.hourType, this.state.entryNumber);
        this.resetEditHourDrawer();
    };
    deleteHour = () => {
        if (this.state.repeatActivated && this.state.repeatEveryUnit != null && this.state.repeatEveryValue > 0) {
            let dateIterator = this.props.hour.date.clone();
            const hour = this.props.hour.hour;
            const name = this.state.name;
            const contact = this.state.contact;
            const repeatEveryValue = this.state.repeatEveryValue;
            const repeatEveryUnit = this.state.repeatEveryUnit;
            const hoursPanel = this.props.hoursPanel;
            const to = this.state.to;
            while (!dateIterator.isAfter(to)) {
                hoursPanel.deleteHourByName(dateIterator, hour, name, contact);
                dateIterator = dateIterator.add(repeatEveryValue, repeatEveryUnit);
            }
        } else {
            this.props.hoursPanel.deleteHour(this.props.hour.date, this.props.hour.hour, this.state.entryNumber);
        }
        this.resetEditHourDrawer();
    };

    resetEditHourDrawer = () => this.setState({name: "", contact: "", hourType: this.props.allowedHourTypes != null && this.props.allowedHourTypes.length > 0 ? this.props.allowedHourTypes[0]: null, entryNumber: 0, nameError: false, agbAccepted: false,});

    handleKeyPress = (e, field) => {
        if (e.keyCode === 13) {
            e.preventDefault(); // Prevent form submission if button present
            let next = this.refs[field.name].nextSibling;

            if (next && next.tagName === "INPUT") {
                this.refs[field.name].nextSibling.focus();
            }
        }
    };
    checkContactDataInput = (contactData, value) => {
        if (this.props.isAdmin) {
            return true;
        }
        if (contactData === C.CONTACT_DATA_NONE) {
            return true;
        } else if (contactData === C.CONTACT_DATA_CELLPHONE) {
            return value.match(/[+]{0,1}[0-9]{7,16}$/) != null;
        } else if (contactData === C.CONTACT_DATA_EMAIL) {
            //http://emailregex.com/
            return value.match(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/) != null;
        }
        return true; //actually an error
    };

    changeNameAdminMode = (name) => () => {
        let nameFound = false;
        $.map(this.convertEntries(), (entry) => {
            if (entry.name == name) {
                nameFound = true;
                this.setState({
                    hourNameSuggestionsOpen: false,
                    name: name,
                    entryNumber: entry.entryNumber,
                    contact: entry.contact,
                    hourType: entry.type
                });
            }
        });
        if (!nameFound) {
            this.setState({name: name, hourNameSuggestionsOpen: false,});
        }
    }
}

EditHourDrawer.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles, {name: "hourPanel"})(EditHourDrawer);
